import {
  MultiSelect as KendoMultiselect,
  MultiSelectChangeEvent,
  MultiSelectProps,
} from '@progress/kendo-react-dropdowns';
import _ from 'lodash';
import { ValidationError } from '../../apps/benefit/models/Errors';
import ErrorViewer from './ErrorViewer';

interface MultiselectCustomProps {
  controlClassName?: string;
  popupClassName?: string;
  mandatory?: boolean;
  helper?: string;
  errors?: ValidationError[];
  clearErrors?: () => void;
}

type MultiselectProps = MultiselectCustomProps & MultiSelectProps;

export default function Multiselect(props: MultiselectProps) {
  const {
    errors,
    onChange,
    clearErrors,
    label,
    id,
    controlClassName,
    popupClassName,
    mandatory,
    helper,
  } = props;
  const internalOnChange = (e: MultiSelectChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };

  const classNames = `control-group ${controlClassName ?? ''} ${
    errors ? 'control-error' : ''
  }`.trim();

  const popupSettings = {
    className: popupClassName,
  };

  return (
    <div className={classNames}>
      <div className="control-content">
        {!!label && (
          <label htmlFor={id}>
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}
        <KendoMultiselect
          {..._.omit(props, [
            'label',
            'popupSettings',
            'mandatory',
            'clearErrors',
          ])}
          onChange={internalOnChange}
          popupSettings={popupSettings}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
}
